"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _data = require("../../utils/data.js");
var _myApi = require("../../api/myApi.js");
var _vant = require("vant");
var _default = exports.default = {
  name: 'Home',
  props: {
    title: {
      type: String,
      default: '测试'
    }
  },
  data: function data() {
    return {
      SdcIdTypeEnum: _data.SdcIdTypeEnum,
      formData: {
        beneficiaryName: '',
        idType: '',
        idNumber: ''
      },
      rules: {
        beneficiaryName: [{
          required: true,
          message: '请输入权益人姓名',
          trigger: 'blur'
        }],
        idType: [{
          required: true,
          message: '请选择权益人证件类型',
          trigger: 'change'
        }],
        idNumber: [{
          required: true,
          message: '请输入权益人证件号',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;
      var _this$formData = this.formData,
        beneficiaryName = _this$formData.beneficiaryName,
        idType = _this$formData.idType,
        idNumber = _this$formData.idNumber;
      if (beneficiaryName && idType && idNumber) {
        (0, _myApi.userQuery)(this.formData).then(function (res) {
          console.log(res);
          if (res.code === 200) {
            _this.$emit('inspect', _this.formData, false);
          } else {
            _this.$emit('inspect', {}, true);
          }
          (0, _vant.Toast)(res.msg);
        });
      }
    }
  }
};